import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import LeadsConfig from '../../../consts/LeadsConfig';

/**
 * Etapas do funil na ordem do kanban. `tone` escolhe a cor da coluna
 * (LeadsBoard.module.css). "Inválido" não é status: vem de `valid == "0"`.
 */
export const LEAD_STAGES = [
  { key: LeadsConfig.StatusNew, label: 'Novo', Icon: AutoAwesomeOutlinedIcon, tone: 'blue', emptyText: 'Contatos novos aparecem aqui.' },
  { key: LeadsConfig.StatusInProgress, label: 'Em andamento', Icon: ForumOutlinedIcon, tone: 'amber', emptyText: 'Nenhuma conversa em andamento.' },
  { key: LeadsConfig.StatusWaitingResponse, label: 'Aguardando retorno', Icon: HourglassEmptyRoundedIcon, tone: 'violet', emptyText: 'Ninguém aguardando retorno.' },
  { key: LeadsConfig.StatusFinished, label: 'Finalizado', Icon: TaskAltRoundedIcon, tone: 'green', emptyText: 'Leads finalizados aparecem aqui.' },
];

export const INVALID_STAGE = { key: 'invalid', label: 'Inválido', Icon: BlockRoundedIcon, tone: 'gray', emptyText: 'Nenhum lead marcado como inválido.' };

// Ordem usada pelas setas do card (o "Inválido" fica fora do avanço)
const STATUS_ORDER = LEAD_STAGES.map((stage) => stage.key);

export const stageLabel = (status) => LEAD_STAGES.find((stage) => stage.key === status)?.label || '';

export const getNextStatus = (status) => {
  const index = STATUS_ORDER.indexOf(status);
  return index >= 0 && index < STATUS_ORDER.length - 1 ? STATUS_ORDER[index + 1] : status;
};

export const getPreviousStatus = (status) => {
  const index = STATUS_ORDER.indexOf(status);
  return index > 0 ? STATUS_ORDER[index - 1] : status;
};
